import gql from 'graphql-tag'

export const fetchMinCartForCatalogQuery = gql(`
query ($cart_id: String!) {
  cart(
      cart_id: $cart_id
  ) {
    note_for_driver
    customer_order_number
    delivery_date
    delivery_method
    progress_bar_data {
      iMinimumOrderPallet
      iMaximumOrderPallet
      iMinimumOrderWeight
      iMaximumOrderWeight
      iMinimumUnit
      iMaximumUnit
      iKegFlag
      iCustomerType
      iTotalCartWeight
      iTotalCartPalletQty
      iTotalQty
      msg
      canProceed
    }
    id
    ship_to_id
    grand_total_your_price_details
    items {
      id
      prices {
        price_details
        multi_deposit_details
        total_item_discount {
          value
        }
        price {
          value
        }
        favourites
        row_total {
          value
        }
        discounts {
          label
          amount {
            value
          }
        }
        total_your_price
        total_your_price_tax
        your_price
        your_price_tax
      }
      product {
        id
        name
        number_of_items_in_box
        package_type
        sku
        image {
          url
        }
        __typename
      }
      quantity
     number_of_pallet_from_fe
      number_of_layer_from_fe
      quantity_from_fe
      number_of_pallet
      number_of_layer
      quantity_total
      product {
       number_of_products_on_layer
       }
      ... on BundleCartItem {
        bundle_options {
          uid
          label
          type
          values {
            uid
            id
            label
            price
            quantity
          }
        }
      }
    }
  }
}
`)
